import { LeftRightBasedExpression } from '../LeftRightBasedExpression.js';
export class OrExpression extends LeftRightBasedExpression {
    evaluate(visitor, localVariables) {
        const { left, right } = this._evaluateLeftRightExpression(visitor, localVariables);
        return left || right;
    }
}
//# sourceMappingURL=OrExpression.js.map